//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {
//   getCommonParam
// } from '../../api/public'

export default {
  name: 'CompanyIntroduce',
  data () {
    return {
      title: '潮州侨联',
      content: null
    }
  },
  created () {
    // this.getAboutUs()
  },
  methods: {
    // getAboutUs () {
    //   getCommonParam('ABOUT_US').then(res => {
    //     this.content = res.data.content
    //   })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/company/introduce.vue